import React from 'react';
import { Col, List, Row, Typography } from 'antd';
import { Table } from '@shared/Table';

interface ResumeModalContentProps {
    dataSource: { title: string, value: any }[][]
    columns: any[]
    tableData: any[]
}

export default function ResumeModalContent({ dataSource, columns = [], tableData = [] }: ResumeModalContentProps) {
    return <Row style={{ flexDirection: 'column' }} gutter={[0, 24]}>
        <Row gutter={24}>
            {
                dataSource.map((item, index) => (
                    <Col span={24 / dataSource.length} key={index}>
                        <List itemLayout="horizontal" dataSource={item} renderItem={(item, index) => (
                            <List.Item>
                                <List.Item.Meta title={<Typography.Text style={{ fontWeight: 500, color: '#747A83' }}>{item.title}</Typography.Text>} />
                                <div>{item.value}</div>
                            </List.Item>
                        )} />
                    </Col>
                ))
            }
        </Row>
        <Row>
            <Table
                tableKey="salaryCardTable111"
                sticky
                pagination={false}
                editColumns={columns}
                dataSource={tableData || []}
                size="small"
                hideSelectAll
                scroll={{ x: 1500, y: 300 }}
            />
        </Row>
    </Row>;
}